import { reactive } from 'vue'
import StorageService from '@/services/StorageService'

const key = 'user'

const userStore = reactive({
  user: null
})

async function persist() {
  await StorageService.set(key, userStore)
}

const UserStore = {
  key,

  getUser() {
    return userStore.user
  },

  async setUser(user) {
    userStore.user = user
    await persist()
  },

  getStore() {
    return userStore
  },

  setStore({ user = null } = {}) {
    userStore.user = user
  },

  async reset(user = null) {
    this.setStore({ user })
    await persist()
  }
}

export default UserStore
